module.exports = __webpack_public_path__ + "assets/media/ai-ios.eaf75406.mp4";